
export default {
  // Profile
  "profile_reviews": "Avis",
  "profile_no_reviews": "Pas encore d'avis",
  "profile_share_experience": "Partagez votre expérience avec la communauté argentique !",
  "verified_traveler": "Voyageur vérifié",
  "verified_creative": "Créatif vérifié",
  "verified_traveler_tooltip": "Cet utilisateur est un voyageur vérifié",
  "verified_creative_tooltip": "Photographe ou professionnel créatif vérifié",
  "favorite_airports": "Aéroports Favoris",
  "no_favorite_airports": "Pas encore d'aéroports favoris",
  "user_favorites": "Favoris de l'Utilisateur",
  "manage_favorites": "Gérer les Favoris"
};
